import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconMenu = createIcon({
  displayName: 'IconMenu',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M21 6H3V8H21V6ZM21 11H3V13H21V11ZM3 16H21V18H3V16Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
